<template>
  <div class="loginContainer">
    <div class="loginBox contentBox">
      <div><button @click="login">Login With Google</button></div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
require('firebase/auth')

export default {
  name: 'login',
  methods: {
    login: function() {
      var provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().signInWithPopup(provider).then(
        () => {
          this.$store.dispatch("checkUser").then(()=>{
            this.$router.push("/")
          })
        },
        (err) => {
          alert(err.message)
        }
    )
    }
  }
}
</script>

<style>
.loginBox {
  display: flex;
  padding: 50px;
  flex-wrap: wrap;
}
.loginBox>div {
  width: 100%;
  display: flex;
  justify-content: center;
}
.loginBox button {
  background-color: #6A7CE9;
  border: none;
  padding: 15px;
  color: white;
  font-size: inherit;
  border-radius: 5px;
}
h3 {
  width: 100%;
  text-align: center;
}
.loginContainer {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
